import React from 'react';
import {useStyles} from "./ShowArticleSourceTarget.style";
import ShowArticleSourceTargetProperties from "./ShowArticleSourceTargetProperties";
import { ArticleTransactionEntityType } from '../../../model/articleTransaction/ArticleTransactionResponse';

const ShowArticleSourceTarget: React.FC<ShowArticleSourceTargetProperties> = ({
                                                          text,
                                                          title,
                                                          type,
                                                          amountBefore,
                                                          className = '',
                                                      }) => {
    const classes = useStyles();

    return (
        <div className={className}>
            <>
                {<div className={classes.title}>{title}</div>}
                <div>{text ? text : '-'}</div>
                {text && <div className={classes.subInfo}>
                    <div className={classes.subLabel}>Tipo:</div>
                    <div className={classes.subValue}>
                        {type ? ArticleTransactionEntityType[type as keyof typeof ArticleTransactionEntityType] : "-"}
                    </div>
                </div>}
                {text && amountBefore != null && <div className={classes.subInfo}>
                    <div className={classes.subLabel}>Cantidad anterior:</div>
                    <div className={classes.subValue}>{amountBefore}</div>
                </div>}
            </>
        </div>
    )
}
export default ShowArticleSourceTarget;